
document.addEventListener('DOMContentLoaded', () => {
  // Use event delegation - attaches once globally
  document.body.addEventListener('click', async (e) => {
    const btn = e.target.closest('.product-card__buy-now');
    if (!btn) return; // Ignore if not Buy Now button clicked

    e.preventDefault();

    const variantId = btn.dataset.variantId;
    const productUrl = btn.dataset.productUrl || '/';

    // If no variant ID found, go to product page
    if (!variantId) {
      window.location.href = productUrl;
      return;
    }

    const originalText = btn.textContent;
    btn.textContent = 'Processing...';
    btn.disabled = true;

    try {
      // 🔹 Clear the cart first (so only 1 product remains)
      await fetch('/cart/clear.js', { method: 'POST' });

      // 🔹 Add only this single product
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      });

      if (!addResponse.ok) {
        let errorMessage = 'Failed to add item.';
        try {
          const errorData = await addResponse.json();
          if (errorData.message) errorMessage = errorData.message;
          if (errorData.description) errorMessage = errorData.description;
        } catch (_) {}
        throw new Error(errorMessage);
      }

      // 🔹 Redirect straight to checkout
      window.location.href = '/checkout';

    } catch (error) {
      console.error('Buy Now Error:', error);
      alert(error.message || 'Something went wrong, please try again.');
      btn.textContent = originalText;
      btn.disabled = false;
    }
  });
});

